window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};

window.NPS.Views.Editor = (function($, _) {

    function editor(el, opts) {
        var
            $el = $(el),
            self = this
        ;

        this.$el = $el;
        this.el = $el.get(0);

        opts = _.defaults({}, opts);
        opts.root = opts.root || '.';

        this.opts = opts;
        this.data = opts.data || {};

        this.view = null;
        this.page = null;
        this.path = opts.path;
        this.callbacks = {};
    }

    editor.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };
    editor.prototype.show = function (page, init) {
        var self = this,
            $el = this.$el.show(),
            $modal = $el.closest('.nps-modal')
        ;

        self.load(page || 'index', init).then(function() {
            $modal.addClass('is-visible');
        });


        // mise en place de la fenêtre modale
        if (!$modal.length) {
            $el.wrap("<div class='nps-modal'></div>");
            $modal = $el.closest('.nps-modal');
        }
        $modal.off();

        if (!this.unquakable) {
            $modal.on('click mousedown mouseup', function(e) {
                e.stopPropagation();
                $('body').trigger('quake');
                $el.trigger('tremor', {target: e.target});
            });
        }

        // mise en place des événements globaux de l'éditeur
        // bouton précédent
        $el.on('click.npseditor', '[data-action="previous"]', function() {
            self.fire('previous');
        });
        // bouton suivant
        $el.on('click.npseditor', '[data-action="next"]:not(.ExternalButtonDisabled)', function() {
            self.fire('next');
        });
        // bouton de fermeture
        $el.on('click.npseditor', '.closer', function() {
            self.hide();
        });
        // changement de page
        $el.on('click.npseditor', '[data-topage]', function() {
            self.load($(this).data('topage'));
        });

        // éditeurs de texte NPS
        $el.on('mousedown.npseditor', '.editr',  function(e) {
            e.stopPropagation();
            TextEditor.rise($(this), e);
        });
        $el.on('click.npseditor mouseup.npseditor', '.editr',  function(e) {
            e.stopPropagation();
        });
        $el.on('focus.npseditor', '.editrfocus',  function() {
            TextEditor.rise($(this).next('.editr'));
            return false;
        });
        $el.on('click.npseditor', '.editr a',  function(e) {
            e.preventDefault();
        });

        return this;
    };
    editor.prototype.hide = function () {
        this.$el
            .hide()
            .off('.npseditor')
            .empty()
            .closest('.nps-modal').removeClass('is-visible')
        ;

        if (this.view && this.view.unstage) {
            this.view.unstage();
            this.view = null;
        }

        return this;
    };

    editor.prototype.load = function (page, data, done) {
        var self = this, $el = self.$el, loadinfo = this.opts.loader ? this.opts.loader[page] : {};

        loadinfo = loadinfo || {};
        data = _.defaults({}, data, loadinfo.data || {}, this.data, {gsite: this.data.site});

        if (self.view && self.view.unstage) {
            self.view.unstage();
            self.view = null;
        }

        var url = loadinfo.url ? loadinfo.url : this.url(page + '.htm');
        return $.post(url, data).then(function(resp) {
            self.page = page;
            $el.html(resp);

            return {
                page: page,
                loader: {
                    url: url,
                    data: data
                }
            };
        }).then(function(r) {
            return done ? done.call(self, r) : r;
        });
    };

    editor.prototype.fire = function (event, data) {
        _.each(this.callbacks, function(events, key) {
            _.each(events[event], function(f) {
                f.call(this, data);
            });
        });
    };
    editor.prototype.register = function (key, event, cb) {
        this.callbacks[key] = this.callbacks[key] || {};
        this.callbacks[key][event] = this.callbacks[key][event] || [];
        this.callbacks[key][event].push(cb);
    };
    editor.prototype.unregister = function (key, event, cb) {
        delete this.callbacks[key];
    };

    editor.prototype.enable = function (step) {
        this.setState(step, true);
        return this;
    };
    editor.prototype.disable = function (step) {
        this.setState(step, false);
        return this;
    };
    editor.prototype.setState = function (step, state) {
        this.$el.find('[data-action="'+ step +'"]').toggleClass('ExternalButtonDisabled', !state);
        return this;
    };
    editor.prototype.url = function (page) {
        return this.path + page;
    };
    return editor;

})(window.jQuery, window._);